import React from "react";
import ReactDOM from "react-dom";
import CustomCMSApp from "./NGO/Main";

ReactDOM.render(<CustomCMSApp />, document.getElementById("root"));
